// @flow

export default (props) => {
  switch (props.decorator || props.is) {
    case 'EshopPhotogallery':
      return import('fg-frontend/components/EshopPhotogallery');
    case 'EshopModel3D':
      return import('fg-frontend/components/EshopModel3D');
    case 'EshopImageMagnify':
      return import('fg-frontend/components/EshopImageMagnify');
    case 'EshopGalleryPopup':
      return import('fg-frontend/components/EshopGalleryPopup');
    case 'EshopOrderForm':
      return import('./components/EshopOrderForm');
    case 'EshopFulltextAutocomplete': // ESHOP: fulltextovy naseptavac, povolte, pokud je aktivni fulltext feature
      return import('fg-frontend/src/components/EshopFulltextAutocomplete');
    case 'FaqFulltextAutocomplete': // fulltextovy naseptavac, povolte, pokud je aktivni fulltext feature
      return import('./components/FaqFulltextAutocomplete');
    case 'ProductListSlider': // ESHOP: product slider
      return import('./components/ProductListSlider');
    case 'BranchPicker': // ESHOP: vyber pobocky v ramci vybranych doprav - povolte, kdyz mate na widgetu pro vyber dopravy nastavene metadato <enableBranchPicker>true</enableBranchPicker>
      return import('fg-frontend/src/components/BranchPicker');
    case 'ColorDescriptionModal': // ESHOP: ovládání modálního okna pro popis variantní barvy
      return import('./components/ColorDescriptionModal');
    case 'EshopVariantStockHandler': // ESHOP: detail produktu, komponenta productDetailVariantForm - povolte, pokud je na komponente nastaveno metadato <enableVariantStockHandler>true</enableVariantStockHandler>
      return import('./eshop/EshopVariantStockHandler');
    case 'EshopUserToolsHandler': // ESHOP: Handler komponenta pro pridani/odebrani produktu z oblibenych/porovnavani (odeberte, pokud na projektu nepouzivate ani oblibene ani porovnavani)
      return import('./components/EshopUserToolsHandler');
    case 'DivaSpheres': // ESHOP: ovladani produktu Diva a Spheres
      return import('./components/DivaSpheres');
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureEshopComponents.js